/**
 * 주간업무보고 편집 (/adm/project/weekly)
 * ($j.Pages.Admin.Weekly / body data-page-name="Weekly")
 *
 * CLI 가 만든 초안을 담당자가 다듬는 화면.
 *   ① 주차 선택·개설(이번 주 수동 개설 가능), 확정 전환, md 미리보기 (LLM 초안은 jbbuller_ops 의 weekly/weekly.sh)
 *   ② 유형 탭(프로젝트/버그/대기 업무 — 옛 주차는 차주 예정) + 담당자 필터 — 본인 것만 골라 다듬는다
 *   ③ 프로젝트 항목 인라인 수정 / 누락분 수기 추가 / 근거 커밋 펼쳐보기
 *       (진행률은 여기서 다루지 않는다 — 원장(프로젝트 관리)이 단일 출처)
 *   ④ 버그·이슈는 담당자당 한 칸 — 건별 관리 없이 자유 텍스트로 받는다
 *
 * 렌더는 전부 여기서 한다(Blade 는 셸만). 저장 후에는 화면을 다시 불러 서버 값과 맞춘다.
 */
import Util from '../../Common/Util';
export default class Weekly {
    initialize() {
        this.data = null;
        this.wrNum = 0;
        this.activeTab = 'project';   // 'project' | 'bug' | 'next'
        this.filterMb  = 0;           // 담당자 필터 (0 = 전체)
        this.openCommits = {};        // 항목별 근거 커밋 펼침 상태

        this._bindBar();
        this._bindBody();
        this._load();
    }

    /* ── 로드 ───────────────────────────────────────── */

    async _load(num) {
        try {
            const res = await $.post('/adm/ajax/project/weekly/data', { num: num || this.wrNum || '' });
            if (!res.result) return Util.swalert(res.message || '불러오지 못했습니다.');

            this.data = res;
            this.wrNum = res.report ? parseInt(res.report.num) : 0;

            // 걸어둔 담당자가 목록에서 사라졌으면(퇴사·부서이동) 전체로 되돌린다
            if (this.filterMb && !(res.members || []).some(m => parseInt(m.num) === this.filterMb)) {
                this.filterMb = 0;
            }

            this._renderBar();
            this._renderFilter();
            this._renderTabs();
            this._renderBody();
        } catch (e) {
            Util.swalert('불러오지 못했습니다.');
        }
    }

    get isFixed() {
        return this.data?.report?.wr_status === '확정';
    }

    /* ── 상단 바 ────────────────────────────────────── */

    _bindBar() {
        $('#wkWeek').on('change', (e) => {
            this.activeTab = 'project';
            this._load(parseInt($(e.currentTarget).val()));
        });

        $('#wkConfirm').on('click', () => this._toggleFixed());
        $('#wkOpen').on('click', () => this._openThisWeek());
        $('.wk-preview').on('click', (e) => this._preview($(e.currentTarget).data('format')));
        // 가이드 토글 — 한 번에 하나만 열린다
        $('.wk-guide-btn').on('click', (e) => {
            const $btn = $(e.currentTarget);
            const id = $btn.data('guide');
            const open = $(`#${id}`).is(':visible');

            $('.wk-guide').slideUp(120);
            $('.wk-guide-btn').removeClass('on');
            if (!open) {
                $(`#${id}`).slideDown(120);
                $btn.addClass('on');
            }
        });
    }

    _renderBar() {
        const r = this.data.report;

        const opts = (this.data.weeks || []).map(w =>
            `<option value="${w.num}" ${parseInt(w.num) === this.wrNum ? 'selected' : ''}>${w.wr_start} ~ ${w.wr_end} · ${w.wr_status} (${w.item_cnt}건)</option>`
        ).join('');
        $('#wkWeek').html(opts || '<option value="">주차 없음</option>');

        if (!r) {
            $('#wkStatus').html('');
            $('#wkMeta').text('주차가 없습니다. [이번 주 개설]로 직접 만들거나, jbbuller_ops 의 weekly/weekly.sh 로 초안을 생성하세요.');
            $('#wkConfirm, .wk-preview').prop('disabled', true);   // 개설(wkOpen)은 활성 유지
            return;
        }

        const badge = { '초안': 'secondary', '편집중': 'info', '확정': 'success' }[r.wr_status] || 'secondary';
        $('#wkStatus').html(`<span class="badge badge-${badge}">${r.wr_status}</span>`);

        const repo = this.data.by_repo || {};
        const total = Object.values(repo).reduce((a, b) => a + b, 0);
        const meta = [`${r.wr_start} ~ ${r.wr_end}`];
        // by_repo 는 서버가 저장소 순서대로 준다 — 표기는 'jbbuller_' 접두어만 뗀다 (WeeklyReportService::repoLabel)
        const parts = Object.entries(repo).map(([k, n]) => `${k.replace(/^jbbuller_/, '')} ${n}`);
        if (total) meta.push(`커밋 ${total}건 (${parts.join(' · ')})`);
        if (r.wr_generated_at) meta.push(`초안 생성 ${r.wr_generated_at}`);
        if (r.wr_confirmed_at) meta.push(`확정 ${r.wr_confirmed_at}`);
        $('#wkMeta').text(meta.join(' · '));

        $('#wkConfirm, .wk-preview').prop('disabled', false);
        $('#wkConfirm').text(this.isFixed ? '확정 해제' : '확정')
                       .toggleClass('btn-primary', !this.isFixed)
                       .toggleClass('btn-default', this.isFixed);
    }

    /**
     * 이번 주 주차 수동 개설 — 빈 초안을 만들고 연다(멱등). 이후 항목을 직접 추가하면 되고,
     * 나중에 weekly.sh(LLM)를 돌려도 수기·편집분은 덮어쓰지 않고 머지된다.
     */
    async _openThisWeek() {
        const res = await $.post('/adm/ajax/project/weekly/open', {});
        if (!res.result) return Util.swalert(res.message || '개설하지 못했습니다.');
        this.activeTab = 'project';
        await this._load(res.num);
        Util.swalert(`${res.wr_start} ~ ${res.wr_end} 주차를 열었습니다. 항목을 직접 추가하거나, 나중에 LLM 초안이 머지됩니다.`);
    }

    async _toggleFixed() {
        const next = this.isFixed ? '편집중' : '확정';
        const msg = this.isFixed
            ? '확정을 해제하고 다시 편집하시겠습니까?'
            : '이 주차를 확정하시겠습니까? 확정 후에는 수정할 수 없습니다.';

        Util.swalert(msg, async () => {
            const res = await $.post('/adm/ajax/project/weekly/status', { num: this.wrNum, status: next });
            if (!res.result) return Util.swalert(res.message || '상태를 바꾸지 못했습니다.');
            this._load();
        }, [next, '취소']);
    }

    /**
     * 미리보기 — html 은 대표가 보는 모양, md 는 제출 원문.
     * 다운로드는 md 쪽에만 둔다 (제출물이 md 라서).
     */
    async _preview(format) {
        const res = await $.post('/adm/ajax/project/weekly/preview', { num: this.wrNum });
        if (!res.result) return Util.swalert(res.message || '미리보기를 만들지 못했습니다.');

        if (format === 'md') {
            $j.Ui.JBModal.html('wkPreviewModal',
                `<div id="wkPreviewBox">${this._esc(res.markdown)}</div>
                 <div class="text-right mt-2">
                    <a href="/adm/project/weekly/markdown?num=${this.wrNum}" class="btn btn-primary btn-sm">
                        <i class="fas fa-download"></i> md 다운로드
                    </a>
                 </div>`,
                'md 원문', { width: '900px' });
            return;
        }

        // 서버에서 raw HTML 을 걷어낸(strip) 결과라 그대로 넣는다
        $j.Ui.JBModal.html('wkPreviewModal',
            `<div id="wkHtmlBox">${res.html}</div>`,
            '미리보기', { width: '900px' });
        // 마스터플랜 캘린더는 자리만 와 있다 — 브라우저가 그린다
        $('#wkHtmlBox .rp-mpcal').each((_, el) => $j.F.Admin.MasterCalendar.mount(el, { ...$(el).data('mpc'), readonly: true, colorBy: 'project' }));
    }

    /* ── 담당자 필터 ────────────────────────────────── */

    /**
     * 담당자 필터 버튼. 건수는 지금 보고 있는 탭 기준이고, 필터가 걸려 있어도
     * 전원의 건수를 그대로 보여준다 — 누가 아직 안 썼는지 여기서 바로 보인다.
     */
    _renderFilter() {
        const members = this.data.members || [];
        if (!this.data.report || !members.length) return $('#wkFilter').empty();

        // 버튼마다 담당자 색을 입힌다(뱃지와 같은 색표). 고른 버튼만 테두리가 생기고 진해진다
        const btn = (num, label) => {
            const on = this.filterMb === num;
            const [bg, fg] = num ? this._pastel(label) : ['#E5E9EE', '#455260'];
            const style = `background:${bg};color:${fg};border-color:${on ? fg : 'transparent'}`;
            return `<button type="button" class="wk-f${on ? ' on' : ''}" style="${style}" data-mb="${num}">`
                 + `${this._esc(label)}<span class="wk-f-cnt">${this._memberCount(num)}</span></button>`;
        };

        $('#wkFilter').html(
            '<span class="wk-f-label">담당자</span>' + btn(0, '전체')
            + members.map(m => btn(parseInt(m.num), m.manage_name)).join('')
        );

        $('#wkFilter').off('click').on('click', '.wk-f', (e) => {
            const mb = parseInt($(e.currentTarget).data('mb')) || 0;
            this.filterMb = this.filterMb === mb ? 0 : mb;   // 같은 버튼을 다시 누르면 해제
            this._renderFilter();
            this._renderTabs();
            this._renderBody();
        });
    }

    /** 담당자별 건수 — 활성 탭 기준. num=0 이면 전원 합계 */
    _memberCount(num) {
        if (this.activeTab === 'project') {
            return (this.data.items || [])
                .filter(i => i.wi_type === 'project' && (!num || parseInt(i.manage_num) === num)).length;
        }

        const store = (this.activeTab === 'bug' ? this.data.bug_text : this.data.next_text) || {};
        return (this.data.members || [])
            .filter(m => !num || parseInt(m.num) === num)
            .reduce((n, m) => n + this._countLines(store[m.num]), 0);
    }

    /** 필터를 통과한 항목 / 담당자 — 본문·탭 건수는 전부 이 둘을 기준으로 한다 */
    _visibleItems() {
        const items = this.data.items || [];
        return this.filterMb ? items.filter(i => parseInt(i.manage_num) === this.filterMb) : items;
    }

    _visibleMembers() {
        const members = this.data.members || [];
        return this.filterMb ? members.filter(m => parseInt(m.num) === this.filterMb) : members;
    }

    /* ── 유형 탭 ────────────────────────────────────── */

    _renderTabs() {
        const items  = this._visibleItems();
        const pjCnt  = items.filter(i => i.wi_type === 'project').length;
        const bugCnt = this._sumLines(this.data.bug_text);
        const nxtCnt = this._sumLines(this.data.next_text);

        const tab = (key, label, cnt, cls) =>
            `<li class="nav-item"><a href="#" class="nav-link ${this.activeTab === key ? 'active' : ''}" data-tab="${key}">${label} <span class="badge badge-${cnt ? cls : 'light'}">${cnt}</span></a></li>`;

        $('#wkTabs').html(
            tab('project', '프로젝트', pjCnt, 'info') +
            tab('bug', '버그·이슈', bugCnt, 'warning') +
            tab('next', (this.data.next_label || {}).tab || '차주 예정', nxtCnt, 'success')
        );

        $('#wkTabs').off('click').on('click', 'a', (e) => {
            e.preventDefault();
            this.activeTab = $(e.currentTarget).data('tab');
            this._renderFilter();   // 필터 버튼의 건수도 탭을 따라간다
            this._renderTabs();
            this._renderBody();
        });
    }

    /** 화면에 보이는 담당자들의 줄 수 합계 (필터가 걸리면 그 사람 것만) */
    _sumLines(store) {
        return this._visibleMembers().reduce((n, m) => n + this._countLines((store || {})[m.num]), 0);
    }

    /* ── 본문 ───────────────────────────────────────── */

    _renderBody() {
        if (!this.data.report) {
            $('#wkBody').html('<div class="text-muted">주차가 없습니다. 상단 <b>[이번 주 개설]</b> 로 만들거나 <code>jbbuller_ops 의 ./weekly/weekly.sh --auto</code> 를 실행하세요.</div>');
            return;
        }

        if (this.activeTab === 'bug')       $('#wkBody').html(this._memberTextSection('bug'));
        else if (this.activeTab === 'next') $('#wkBody').html(this._memberTextSection('next'));
        else                                $('#wkBody').html(this._projectSection());

        // 펼쳐둔 근거 커밋은 프로젝트 탭에서만 유지
        if (this.activeTab === 'project') {
            Object.keys(this.openCommits).forEach(num => {
                if (this.openCommits[num]) this._loadCommits(parseInt(num));
            });
        }
    }

    /** 프로젝트 탭 — 원장 순서대로 묶고 담당자별 내용이 들어간다 */
    _projectSection() {
        const projects = this._visibleItems().filter(i => i.wi_type === 'project');

        let pjBody = '';
        if (!projects.length) {
            pjBody = `<div class="text-muted" style="font-size:12px">${this.filterMb ? '이 담당자의 항목이 없습니다.' : '해당 항목이 없습니다.'} [+ 항목 추가] 로 넣으세요.</div>`;
        } else {
            this._groupByProject(projects).forEach(g => {
                pjBody += `<div class="wk-pj">
                    <div class="wk-pj-head">${this._esc(g.name)}</div>
                    ${g.items.map(i => this._itemHtml(i)).join('')}
                </div>`;
            });
        }

        return `<div class="wk-sec wk-sec-project">
            <div class="wk-sec-bar">
                <div class="wk-sec-title">프로젝트 <span class="wk-sec-cnt">${projects.length}건</span></div>
                <div class="wk-sec-hint ml-3">계획해서 <b>만드는</b> 일</div>
                <button type="button" class="btn btn-default btn-xs ml-auto wk-add" ${this.isFixed ? 'disabled' : ''}>+ 항목 추가</button>
            </div>
            <div class="wk-sec-body">${pjBody}</div>
        </div>`;
    }

    /** 버그·차주 탭 — 담당자당 자유 텍스트 한 칸(전원 표시) */
    _memberTextSection(type) {
        const isBug   = type === 'bug';
        const store   = (isBug ? this.data.bug_text : this.data.next_text) || {};
        const cls     = isBug ? 'wk-bug' : 'wk-next';
        const secCls  = isBug ? 'wk-sec-bug' : 'wk-sec-next';
        // 'next' 칸의 이름은 주차마다 서버가 정한다 — 캘린더가 들어온 주차부터 '대기 업무' (WeeklyMarkdown::nextLabel)
        const nl      = this.data.next_label || { title: '차주 진행 예정', hint: '다음 주에 할 일 · 한 줄에 한 건', ph: '' };
        const title   = isBug ? '버그 및 이슈' : nl.title;
        const hint    = isBug ? '터져서 <b>되돌리는</b> 일 · 한 줄에 한 건' : nl.hint;
        const ph      = isBug ? '예) 불러톡 알림이 최신 대신 오래된 메시지를 표시하던 문제' : nl.ph;

        const body = this._visibleMembers().map(m => {
            const text = store[m.num] || '';
            return `<div class="wk-item" data-mb="${m.num}">
                <div class="wk-item-head">
                    ${this._ownerBadge(m.manage_name)}
                    <span class="text-muted" style="font-size:11px">${this._countLines(text)}건</span>
                </div>
                <textarea class="wk-body ${cls}" rows="${this._rows(text)}" placeholder="${ph}" ${this.isFixed ? 'readonly' : ''}>${this._esc(text)}</textarea>
            </div>`;
        }).join('');

        return `<div class="wk-sec ${secCls}">
            <div class="wk-sec-bar">
                <div class="wk-sec-title">${title} <span class="wk-sec-cnt">${this._sumLines(store)}건</span></div>
                <div class="wk-sec-hint ml-3">${hint}</div>
            </div>
            <div class="wk-sec-body"><div class="wk-pj">${body}</div></div>
        </div>`;
    }

    _countLines(text) {
        return String(text || '').split('\n').filter(l => l.trim() !== '').length;
    }

    /** 프로젝트 항목 한 줄 (버그는 _renderBody 에서 담당자별 통합 칸으로 그린다) */
    _itemHtml(it) {
        const ro = this.isFixed ? 'readonly' : '';

        return `<div class="wk-item" data-num="${it.num}">
            <div class="wk-item-head">
                ${this._ownerBadge(it.manage_name)}
                ${parseInt(it.wi_is_manual) ? '<span class="wk-manual">수기</span>' : ''}
                <input type="text" class="wk-title" data-field="wi_title" value="${this._esc(it.wi_title)}" placeholder="항목 제목" ${ro}>
                <button type="button" class="btn btn-default btn-xs wk-cmt" title="근거 커밋"><i class="fas fa-code-branch"></i></button>
                <button type="button" class="btn btn-default btn-xs wk-del" title="항목 삭제" ${this.isFixed ? 'disabled' : ''}><i class="fas fa-trash"></i></button>
            </div>
            <textarea class="wk-body" data-field="wi_body" rows="${this._rows(it.wi_body)}" placeholder="진행 내용 — 한 줄이 보고서의 불릿 하나가 됩니다" ${ro}>${this._esc(it.wi_body)}</textarea>
            <div class="wk-commits" style="display:none"></div>
        </div>`;
    }

    _rows(body) {
        const n = String(body || '').split('\n').length;
        return Math.max(2, Math.min(10, n + 1));
    }

    /* ── 본문 이벤트 ────────────────────────────────── */

    _bindBody() {
        const $body = $('#wkBody');

        // 인라인 편집 — 값이 바뀐 채로 포커스를 잃으면 저장 (버그/차주 칸은 제외)
        $body.on('focus', '.wk-title, .wk-body:not(.wk-bug):not(.wk-next)', (e) => {
            $(e.currentTarget).data('orig', $(e.currentTarget).val());
        });
        $body.on('blur', '.wk-title, .wk-body:not(.wk-bug):not(.wk-next)', (e) => {
            const $el = $(e.currentTarget);
            if ($el.val() === $el.data('orig')) return;
            this._saveField($el);
        });

        $body.on('click', '.wk-cmt', (e) => {
            const num = this._itemNum(e);
            this.openCommits[num] = !this.openCommits[num];
            this.openCommits[num] ? this._loadCommits(num) : $(e.currentTarget).closest('.wk-item').find('.wk-commits').hide();
        });

        $body.on('click', '.wk-del', (e) => this._delete(this._itemNum(e)));
        $body.on('click', '.wk-add', () => this._openAddForm());

        // 버그·차주 칸 — 담당자당 한 덩어리로 통째 저장
        $body.on('focus', '.wk-bug, .wk-next', (e) => $(e.currentTarget).data('orig', $(e.currentTarget).val()));
        $body.on('blur', '.wk-bug', (e) => {
            const $el = $(e.currentTarget);
            if ($el.val() === $el.data('orig')) return;
            this._saveMemberText($el, 'bug');
        });
        $body.on('blur', '.wk-next', (e) => {
            const $el = $(e.currentTarget);
            if ($el.val() === $el.data('orig')) return;
            this._saveMemberText($el, 'next');
        });
    }

    _itemNum(e) {
        return parseInt($(e.currentTarget).closest('.wk-item').data('num'));
    }

    _findItem(num) {
        return (this.data.items || []).find(i => parseInt(i.num) === num);
    }

    async _saveField($el) {
        const num = parseInt($el.closest('.wk-item').data('num'));
        const it = this._findItem(num);
        if (!it) return;

        const payload = {
            num,
            wr_num: this.wrNum,
            wi_type: it.wi_type,
            pj_num: it.pj_num || '',
            manage_num: it.manage_num,
            wi_title: it.wi_title || '',
            wi_body: it.wi_body || '',
            wi_sort: it.wi_sort || 0,
        };
        payload[$el.data('field')] = $el.val();

        const res = await $.post('/adm/ajax/project/weekly/item/save', payload);
        if (!res.result) {
            $el.val($el.data('orig')).addClass('wk-dirty');
            return Util.swalert(res.message || '저장하지 못했습니다.');
        }
        // 서버 값과 어긋나지 않도록 로컬 캐시도 갱신 (전체 리로드는 포커스를 잃게 한다)
        it[$el.data('field')] = $el.val();
        $el.removeClass('wk-dirty').data('orig', $el.val());
    }

    /** 버그·차주 저장 — 그 담당자의 해당 타입 항목을 통째로 갈아끼운다 */
    async _saveMemberText($el, type) {
        const manageNum = parseInt($el.closest('.wk-item').data('mb'));
        const url = type === 'bug' ? '/adm/ajax/project/weekly/bug/save' : '/adm/ajax/project/weekly/next/save';

        const res = await $.post(url, { wr_num: this.wrNum, manage_num: manageNum, wi_body: $el.val() });
        if (!res.result) {
            $el.val($el.data('orig')).addClass('wk-dirty');
            return Util.swalert(res.message || '저장하지 못했습니다.');
        }

        // 건수 표기만 갱신 — 전체를 다시 그리면 타이핑 흐름이 끊긴다
        const key = type === 'bug' ? 'bug_text' : 'next_text';
        if (!this.data[key]) this.data[key] = {};
        this.data[key][manageNum] = $el.val();
        $el.closest('.wk-item').find('.wk-item-head .text-muted').text(this._countLines($el.val()) + '건');
        $el.removeClass('wk-dirty').data('orig', $el.val());
    }

    _delete(num) {
        const it = this._findItem(num);
        // 제목은 다른 관리자가 쓴 글이다 — swalert 는 '<' 가 든 문장을 HTML 로 그리므로 텍스트 슬롯(Dialog)으로 연다
        $j.Ui.Dialog.open({
            title:   `"${it?.wi_title || ''}" 항목을 삭제하시겠습니까?`,
            confirm: '삭제',
            cancel:  '취소',
            onConfirm: async () => {
                const res = await $.post('/adm/ajax/project/weekly/item/delete', { num });
                if (!res.result) return Util.swalert(res.message || '삭제하지 못했습니다.');
                this._load();
            },
        });
    }

    /** 자동 생성이 놓친 프로젝트 업무를 손으로 추가 (wi_is_manual=1 로 저장된다) */
    _openAddForm() {
        const defMb = this.filterMb || this.data.my_num;   // 필터 중이면 그 담당자로 열린다
        const members = (this.data.members || [])
            .map(m => `<option value="${m.num}" ${parseInt(m.num) === defMb ? 'selected' : ''}>${this._esc(m.manage_name)}</option>`).join('');
        const projects = (this.data.projects || [])
            .map(p => {
                const hold = p.pj_status === '보류' ? '[보류] ' : '';   // 보류도 고를 수 있게 두되 표시는 남긴다
                return `<option value="${p.num}">${hold}${this._esc(p.pj_name)}</option>`;
            }).join('');

        $j.Ui.JBModal.html('wkAddModal', `
            <div class="row">
                <div class="col-sm-4 form-group">
                    <label>담당자</label>
                    <select id="wkAddMb" class="form-control form-control-sm">${members}</select>
                </div>
                <div class="col-sm-8 form-group">
                    <label>프로젝트</label>
                    <select id="wkAddPj" class="form-control form-control-sm">${projects}</select>
                    <div class="text-muted mt-1" style="font-size:11px">
                        목록에 없으면 프로젝트 관리에서 먼저 등록하세요. 버그·운영 건은 아래 "버그 및 이슈" 칸에 적습니다.
                    </div>
                </div>
            </div>
            <div class="form-group">
                <label>제목</label>
                <input type="text" id="wkAddTitle" class="form-control form-control-sm" placeholder="현황 표에 들어갈 한 줄">
            </div>
            <div class="form-group">
                <label>진행 내용</label>
                <textarea id="wkAddBody" class="form-control form-control-sm" rows="5" placeholder="한 줄이 보고서의 불릿 하나가 됩니다"></textarea>
            </div>
            <div class="text-right">
                <button class="btn btn-default btn-sm" onclick="$j.Ui.JBModal.close('wkAddModal')">취소</button>
                <button class="btn btn-primary btn-sm" id="wkAddOk">추가</button>
            </div>
        `, '프로젝트 항목 추가', { width: '640px' });

        $('#wkAddOk').on('click', async () => {
            const res = await $.post('/adm/ajax/project/weekly/item/save', {
                wr_num: this.wrNum,
                wi_type: 'project',
                pj_num: $('#wkAddPj').val(),
                manage_num: $('#wkAddMb').val(),
                wi_title: $('#wkAddTitle').val(),
                wi_body: $('#wkAddBody').val(),
            });
            if (!res.result) return Util.swalert(res.message || '추가하지 못했습니다.');
            $j.Ui.JBModal.close('wkAddModal');
            this._load();
        });
    }

    /** 근거 커밋 — 서술이 어느 커밋에서 나왔는지 확인 */
    async _loadCommits(num) {
        const it = this._findItem(num);
        if (!it) return;

        const $box = $(`.wk-item[data-num="${num}"] .wk-commits`);
        if (!$box.length) return;
        $box.show().html('<div>불러오는 중…</div>');

        const res = await $.post('/adm/ajax/project/weekly/commits', {
            wr_num: this.wrNum,
            pj_num: it.pj_num || '',
            manage_num: it.manage_num,
        });
        if (!res.result) return $box.html('<div>불러오지 못했습니다.</div>');

        const rows = res.data || [];
        $box.html(rows.length
            ? rows.map(c => `<div>${(c.wc_date || '').substring(5, 10)} ${this._esc(c.wc_repo.replace('jbbuller_', ''))} · ${this._esc(c.wc_prefix || '')}${c.wc_scope ? '(' + this._esc(c.wc_scope) + ')' : ''} ${this._esc(c.wc_subject || '')}</div>`).join('')
            : '<div>연결된 커밋이 없습니다.</div>');
    }

    /* ── 내부 ───────────────────────────────────────── */

    _groupByProject(items) {
        const map = new Map();
        items.forEach(it => {
            const key = it.pj_num || 'etc';
            if (!map.has(key)) {
                map.set(key, {
                    // 원장과 같은 순서(완료 → 진행중, 그 안에서 시작일순)
                    sort: it.pj_num ? `${it.pj_rank || 9}|${it.pj_started || '9999-12-31'}` : '9|9999-12-31',
                    name: it.pj_name || '기타 (원장에 없는 항목)',
                    items: [],
                });
            }
            map.get(key).items.push(it);
        });
        return [...map.values()].sort((a, b) => a.sort.localeCompare(b.sort));
    }

    _esc(s) {
        return String(s ?? '').replace(/[&<>"']/g, c => ({ '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;', "'": '&#39;' }[c]));
    }

    /** 담당자 파스텔 색 — 이름 첫 글자로 고정(홍/박/유/윤 …). 뱃지와 필터 버튼이 공유한다 */
    _pastel(name) {
        const map = { '홍': ['#ECE3FB', '#6A3FA0'], '박': ['#E1ECFB', '#2F5C9E'], '유': ['#E2F3E4', '#37773F'], '윤': ['#FBEFD6', '#8A6612'] };
        return map[String(name ?? '').trim().charAt(0)] || ['#ECEEF1', '#5A6270'];
    }

    /** 담당자 파스텔 뱃지 */
    _ownerBadge(name) {
        const t = String(name ?? '').trim();
        if (!t) return '';
        const [bg, fg] = this._pastel(t);
        return `<span class="ob" style="background:${bg};color:${fg}">${this._esc(t)}</span>`;
    }
}
